export const localNow = (): number =>
  performance.timeOrigin + performance.now();
